module.exports = __webpack_public_path__ + "static/media/filters.1d192648.png";